import {StyleSheet} from 'react-native';
import {Colors} from '../../constants/Colors';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'white',
    paddingHorizontal: 20,
    paddingVertical: 10,
  },
  containerHeader: {
    marginTop: 30,
    marginBottom: 40,
  },
  description: {
    textAlign: 'center',
    fontSize: 15,
    fontFamily: 'TCCC-UnityHeadline Regular',
    maxWidth: 250,
    alignSelf: 'center',
    color: Colors.GrayPallete.lightgrayThree,
  },
  content: {
    paddingHorizontal: 20,
  },
  containerFilter: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 20,
  },
  progress: {
    height: 40,
    borderColor: Colors.GrayPallete.lightgrayTwo,
    // flexDirection: 'row',
    // alignItems: 'center',
    // justifyContent: 'space-between'
  },
  CardContainer: {
    width: '100%',
    minHeight: 109,
    borderWidth: 1,
    borderColor: Colors.lightGray,
    paddingHorizontal: 15,
    marginBottom: 10,
    borderRadius: 5,
  },
  CardContent: {
    height: 150,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  label: {
    fontSize: 16,
    fontWeight: '700',
    lineHeight: 19,
    color: 'black',
  },
  ContainerDate: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 10,
  },
  preDate: {
    fontSize: 12,
    fontWeight: '400',
    lineHeight: 14,
    color: Colors.GrayPallete.lightgrayThree,
  },
  dateText: {
    fontSize: 12,
    fontWeight: '600',
    lineHeight: 14,
    color: Colors.GrayPallete.lightgrayThree,
  },
  ContainerDrop: {
    flexDirection: 'column',
    paddingHorizontal: 20,
    paddingVertical: 50,
  },
  Check: {
    position: 'absolute',
    left: -11,
    backgroundColor: 'white',
  },
  OrderText: {
    marginLeft: 20,
    color: 'black',
    fontFamily: 'TCCC-UnityHeadline Regular',
    fontSize: 12,
    lineHeight: 14,
  },
  OrderTextGray: {
    marginLeft: 20,
    color: Colors.GrayPallete.lightgrayTwo,
    fontFamily: 'TCCC-UnityHeadline Regular',
    fontSize: 12,
    lineHeight: 14,
  },
  OrderSubText: {
    marginTop: 2,
    marginLeft: 20,
    color: Colors.GrayPallete.lightgrayThree,
    fontFamily: 'TCCC-UnityHeadline Regular',
    fontSize: 12,
    lineHeight: 14,
  },
  CheckCenter: {
    position: 'absolute',
    left: -10,
    backgroundColor: 'white',
    justifyContent: 'center',
  },
  smallButton: {
    backgroundColor: Colors.RedPallete.red,
    paddingHorizontal: 5,
    paddingVertical: 0,
    borderRadius: 5,
    marginLeft: 'auto',
    marginTop: 10,
    height: 25,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonText: {
    color: 'white',
    fontSize: 12,
  },
});
